import React from "react";

const MatchStatus = ({ status }) => {
  if (status === "Completed") {
    return (
      <span className="text-green-600 bg-green-100 px-2 py-1 rounded text-xs font-medium">
        Hoàn thành
      </span>
    );
  } else if (status === "In Progress") {
    return (
      <span className="text-orange-600 bg-orange-100 px-2 py-1 rounded text-xs font-medium flex items-center">
        <span className="inline-block w-2 h-2 bg-orange-600 rounded-full mr-1 animate-pulse"></span>
        Đang diễn ra
      </span>
    );
  } else {
    return (
      <span className="text-gray-600 bg-gray-100 px-2 py-1 rounded text-xs font-medium">
        Sắp diễn ra
      </span>
    );
  }
};

export default MatchStatus;
